import {React, useEffect, useState, useRef}  from 'react';
import ExpandedImage from './ExpandedImage.js';
import '../App.css';
import './gallery.css';
import Image1 from '../images/image1.webp';
import Image9 from '../images/image9.webp';
import Image10 from '../images/image10.webp';
import Image12 from '../images/image12.webp';
import Image113 from '../images/image113.webp';
import Image45 from '../images/image45.webp';
import Image48 from '../images/image48.webp';
import Image52 from '../images/image52.webp';
import { GiFruitTree } from "react-icons/gi";

const Gallery = () => {
    const [isVisibleImage9, setIsVisibleImage9] = useState(false);
    const imageRef9 = useRef(null);
    const [expandedImage9, setExpandedImage9] = useState(null);

    const handleScroll9 = () => {
                
                  if (imageRef9.current) {
                    const imageRect9 = imageRef9.current.getBoundingClientRect();
                    const triggerOffsetImage9 = 130; // Adjust this value for different trigger points
                    const triggerPointImage9 = window.innerHeight - triggerOffsetImage9;
                    const isAboveTriggerPointImage9 = imageRect9.top < triggerPointImage9;
                    setIsVisibleImage9(isAboveTriggerPointImage9);
                  }
    
            };
          
            useEffect(() => {
                window.addEventListener('scroll', handleScroll9);
                handleScroll9(); // Check visibility on initial render
                return () => {
                  window.removeEventListener('scroll', handleScroll9);
                };
            }, []);
    
                
                useEffect(() => {
                      const hash = window.location.hash.substring(1);
                      if (hash) {
                        const targetElement = document.getElementById(hash);
                        if (targetElement) {
                            targetElement.scrollIntoView({ behavior: 'smooth' });
                        }
                      }
                  }, []);
    

    const images = [
		{ id: 1, url: Image9, alt: 'Gallery Image 1 Tree Service'},
	  	{ id: 2, url: Image10, alt: 'Gallery Image 2 Tree Service'},
	  	{ id: 3, url: Image12, alt: 'Gallery Image 3 Tree Service'},
	  	{ id: 4, url: Image1, alt: 'Gallery Image 4 Tree Service'},
	  	{ id: 5, url: Image113, alt: 'Gallery Image 5 Tree Service'},
	  	{ id: 6, url: Image45, alt: 'Gallery Image 6 Tree Service' },
	  	{ id: 7, url: Image48, alt: 'Gallery Image 7 Tree Service' },
	  	{ id: 8, url: Image52, alt: 'Gallery Image 8 Tree Service' },
	  ];

	  const prepareImagesWithOrder = (images) => {
		return images.map((image, index) => ({
		  ...image,
		  relatedImages: [
			image.url,
			...images
			  .slice(index + 1)
			  .concat(images.slice(0, index))
			  .map((img) => img.url),
		  ],
		}));
	  };

	  const updatedImages9 = prepareImagesWithOrder(images);

		
	 	const handleGridItemClick9 = (image) => {
			const selectedImage9 = updatedImages9.find((img) => img.id === image.id);
  		setExpandedImage9(selectedImage9);
		const modalContainer = document.querySelector('.modal-container2');
		modalContainer.style.top = '50%'; 
		modalContainer.style.left = '50%';
		modalContainer.style.transform = 'translate(-50%, -50%)'; 
		modalContainer.style.width = '90%'; 
		modalContainer.style.height = '100vh'; 
		document.querySelector('.modal-overlay2').classList.add('show');
		modalContainer.classList.add('show');
		};

		const handleCloseExpandedImage9 = () => {
		setExpandedImage9(null);
		document.querySelector('.modal-overlay2').classList.remove('show');
		document.querySelector('.modal-container2').classList.remove('show');
		};


	return (
		<div id="modulesix9">
                        <div id='modulesix_pic9'>
                        <div id='modulesix_text9'>
                            <div id='icon_six29'>
                                <div id='six_text2_19'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
                                <div id='icon_six_icon29'><GiFruitTree /></div>
                                <div id='six_text2_29'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
                            </div>				
                            <h1>Explore Our Tree Service Expertise</h1>
                        </div>
                        <div id="collect-grid-container9" ref={imageRef9}>
                            {images.map((image) => (
                        
                        <div className={`collect-grid-item9 ${isVisibleImage9  ? 'visible' : ''}`} key={image.id}  style={{ transitionDelay: '.3s' }} onClick={() => handleGridItemClick9(image)}>
                            <img src={image.url} alt={image.alt} />
                        </div>
                    ))}
                        
                    </div>
                    <div className="modal-overlay2"></div>
                    <div className="modal-container2">
                        {expandedImage9 && (
                            <ExpandedImage imageUrl={expandedImage9.url} relatedImages={expandedImage9.relatedImages} onClose={handleCloseExpandedImage9} />
                        )}
                    </div>
                            
                        </div>
                            
                        
        
                    </div>
	);
};

export default Gallery;